import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";
import RuvnlSimulationIndex from "./SimulateProcurement/SimulationIndex";
import { getProcurementRuvnlSession } from "../Utility/RestApi";
import { setOptimizerRuvnlDateRange } from "../../../store/state/ProcurementOptimizer/RuvnlOptimizer/OptimizerDate";
import { setOptimizerRuvnlSession } from "../../../store/state/ProcurementOptimizer/RuvnlOptimizer/OptimizerSession";
import { setOptimizerRuvnlSessionToken } from "../../../store/state/ProcurementOptimizer/RuvnlOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";
import PowerIndex from "./PowerProcurement/PowerIndex";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getProcurementRuvnlSession();
      if (data) {
        dispatch(
          setOptimizerRuvnlDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerRuvnlSession(data.session));
        dispatch(setOptimizerRuvnlSessionToken(data.session_token));
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "power":
        return <PowerIndex />;
      case "simulation":
        return <RuvnlSimulationIndex />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
